var map = {
	"./0/Kambi/SecondaryMenu.layout.js": [
		8017,
		[
			1591,
			3879
		]
	],
	"./0/Poker/SecondaryMenu.layout.js": [
		4131,
		[
			1591,
			8625
		]
	],
	"./0/Spectate/SecondaryMenu.layout.js": [
		33790,
		[
			1591,
			6246
		]
	],
	"./1/Kambi/SecondaryMenu.layout.js": [
		21623,
		[
			1450
		]
	],
	"./1/Poker/SecondaryMenu.layout.js": [
		83330,
		[
			1591,
			7147
		]
	],
	"./1/Spectate/SecondaryMenu.layout.js": [
		97680,
		[
			1591,
			2003
		]
	],
	"./31/Kambi/SecondaryMenu.layout.js": [
		38185,
		[
			1591,
			4391
		]
	],
	"./31/Poker/SecondaryMenu.layout.js": [
		38342,
		[
			1591,
			796
		]
	],
	"./31/Spectate/SecondaryMenu.layout.js": [
		78059,
		[
			1591,
			8068
		]
	],
	"./58/Spectate/SecondaryMenu.layout.js": [
		39885,
		[
			1591,
			2719
		]
	],
	"./75/Kambi/SecondaryMenu.layout.js": [
		66881,
		[
			1591,
			6719
		]
	],
	"./75/Spectate/SecondaryMenu.layout.js": [
		97550,
		[
			1591,
			4724
		]
	],
	"./76/Kambi/SecondaryMenu.layout.js": [
		81061,
		[
			1591,
			9108
		]
	],
	"./76/Spectate/SecondaryMenu.layout.js": [
		5089,
		[
			1591,
			3327
		]
	],
	"./8/Poker/SecondaryMenu.layout.js": [
		23323,
		[
			1591,
			8838
		]
	],
	"./8/Spectate/SecondaryMenu.layout.js": [
		65881,
		[
			1591,
			3800,
			3022
		]
	],
	"./81/Kambi/SecondaryMenu.layout.js": [
		68634,
		[
			1591,
			2522
		]
	],
	"./81/Spectate/SecondaryMenu.layout.js": [
		85447,
		[
			1591,
			1845
		]
	],
	"./84/Kambi/SecondaryMenu.layout.js": [
		45614,
		[
			1591,
			4635
		]
	],
	"./84/Spectate/SecondaryMenu.layout.js": [
		16140,
		[
			1591,
			7484
		]
	],
	"./86/Spectate/SecondaryMenu.layout.js": [
		41529,
		[
			1591,
			5290
		]
	],
	"./87/Spectate/SecondaryMenu.layout.js": [
		88894,
		[
			1591,
			8919
		]
	],
	"./88/Spectate/SecondaryMenu.layout.js": [
		93507,
		[
			1591,
			1288
		]
	],
	"./89/Spectate/SecondaryMenu.layout.js": [
		84560,
		[
			1591,
			5290,
			7709
		]
	],
	"./90/Spectate/SecondaryMenu.layout.js": [
		27186,
		[
			1591,
			5290,
			5883
		]
	],
	"./91/Spectate/SecondaryMenu.layout.js": [
		71917,
		[
			1591,
			5290,
			9774
		]
	],
	"./92/Spectate/SecondaryMenu.layout.js": [
		29860,
		[
			1591,
			7253
		]
	],
	"./94/Spectate/SecondaryMenu.layout.js": [
		58521,
		[
			1591,
			8439
		]
	],
	"./95/Spectate/SecondaryMenu.layout.js": [
		71636,
		[
			1591,
			5738
		]
	],
	"./96/Poker/SecondaryMenu.layout.js": [
		91694,
		[
			1591,
			3545
		]
	],
	"./96/Spectate/SecondaryMenu.layout.js": [
		45780,
		[
			1591,
			3800,
			2593
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 21871;
module.exports = webpackAsyncContext;